import { Col, Container, Row } from "reactstrap";

const SectionContainer = ({ mainId, children, style, className }) => {
  return (
    <Container 
      fluid 
      className={`h-100 ${className || ''}`}
      id={mainId} 
      style={{ zIndex:0, ...style }}  // Merge overflow with passed styles
    >
      <Container className="dynamic-container">
        {children}
      </Container>
    </Container>
  );
};

export default SectionContainer;
